import { z } from "zod";

export const AnswerCategory = z.object({
  id: z.number(),
  content: z.string(),
  is_checked: z.boolean(),
  sub_category_count: z.number(),
});

export type AnswerCategory = z.infer<typeof AnswerCategory>;
